


































































































import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import { Message } from "element-ui";
@Component({})
export default class EnterPrise extends Vue {
  public bjInfo = false;
  public passwordInfo = false;
  public form = {
    address: "",
    companyContacts: "",
    companyName: "",
    contactTel: "",
    currentBalance: 0
  };
  public passwordform = {
    oldPassword: "",
    newPassword: "",
    newPassword2: ""
  };
  public companyInfo = {};
  mounted() {
    this.getCompany();
  }
  getCompany() {
    axios.get("company").then(res => {
      if (res.data.errCode == 0) {
        this.companyInfo = res.data.result;
        this.form = res.data.result;
      }
    });
  }
  editCompany() {
    axios.post("company", this.form).then(res => {
      if (res.data.errCode == 0) {
        Message.success(res.data.errMsg);
        this.getCompany();
        this.bjInfo = false;
      }
    });
  }
  editPassword() {
    axios.post("password", {}, { params: this.passwordform }).then(res => {
      if (res.data.errCode == 0) {
        Message.success(res.data.errMsg);
        this.$router.push("/login");
      } else {
        Message.warning(res.data.errMsg);
      }
    });
  }
}
